module.exports = __webpack_public_path__ + "static/media/ProfileCardMask.57c1cb62.png";